import { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import Api from "../openapi";
import { AdminAddressRequest } from "../openapi/client";
import { IAddressRequest, IAddressResponse } from "../pages/UserDetail";
import { setNotification } from "../store/notificationSlice";
import { checkIf, generateRandom } from "../utils";

export default function useAddress(userId: string) {
  const dispatch = useDispatch();
  const [addressList, setAddressList] = useState<IAddressResponse[]>([]);
  const [addressListRef, setAddressListRef] = useState<IAddressResponse[]>();

  const updateStateItem = (state: IAddressResponse[], targetItem: IAddressRequest & { id?: string }) => {
    let temp: IAddressResponse[] = JSON.parse(JSON.stringify(state));
    let output;
    const findIndex = temp.findIndex((i) => i.id === targetItem.id);

    if (targetItem.default) {
      output = temp.map((i, index) => {
        if (index !== findIndex) {
          return { ...i, default: false, dirty: false };
        } else {
          return { ...i, ...targetItem, default: true, dirty: false };
        }
      });
    } else {
      output = temp.map((i, index) => {
        if (index === findIndex) {
          return { ...i, ...targetItem, dirty: false };
        } else {
          return { ...i };
        }
      });
    }

    // if (temp[findIndex].default) {
    //   // update all the others to false
    //   temp.forEach((i, index, arr) => {
    //     if (index !== findIndex) {
    //       arr[index].default = false;
    //     }
    //   });
    // }
    // temp[findIndex] = { ...targetItem };
    return output;
  };

  const getAddressList = async () => {
    try {
      const res = await Api.Address.getAddressesByAdmin(userId);
      // const response = [...res.data];
      const response = JSON.parse(JSON.stringify(res.data));
      const reference = JSON.parse(JSON.stringify(res.data));
      setAddressList(response);
      setAddressListRef(reference);
    } catch (error) {}
  };

  const updateAddressList = async (addressId: string, payload: IAddressRequest) => {
    try {
      const res = await Api.Address.updateAddressByAdmin(userId, addressId, payload);
      setAddressList((state) => {
        return updateStateItem(state, {
          ...payload,
          id: addressId,
          driver: JSON.parse(JSON.stringify(res.data.driver)),
        });
      });
      setAddressListRef((state) => {
        let temp = JSON.parse(JSON.stringify(state));
        return updateStateItem(temp, {
          ...payload,
          id: addressId,
          driver: JSON.parse(JSON.stringify(res.data.driver)),
        });
      });
      dispatch(
        setNotification({
          show: true,
          severity: "success",
          message: "Address updated successfully!",
        })
      );
    } catch (error: any) {
      dispatch(
        setNotification({
          show: true,
          severity: "error",
          message: error.response?.data?.message || error.message,
        })
      );
    }
  };
  const createAddressItem = async (payload: AdminAddressRequest & { id?: string; driverId?: string }) => {
    try {
      const res = await Api.Address.createAddressByAdmin(userId, payload);
      setAddressList((state) => {
        let temp = [...state];
        const findIndex = temp.findIndex((i) => i.id === payload.id);

        if (temp[findIndex].default) {
          // update all the others to false
          temp.forEach((i, index) => {
            if (index !== findIndex) {
              temp[index].default = false;
            }
          });
        }
        temp[findIndex] = { ...res.data };
        return temp;
      });
      setAddressListRef((state) => {
        let temp = [...(state as IAddressResponse[])];
        if (res.data.default) {
          temp.forEach((i, index) => {
            temp[index].default = false;
          });
        }
        temp.push(res.data);
        return temp;
      });
      return res.data;
    } catch (error: any) {
      dispatch(
        setNotification({
          show: true,
          severity: "error",
          message: error.response?.data?.message || error.message,
        })
      );
    }
  };

  const deleteAddressItem = async (addressId: string) => {
    try {
      await Api.Address.deleteAddressByAdmin(userId, addressId);
      setAddressList((state) => {
        return state.filter((i) => i.id !== addressId);
      });
      setAddressListRef((state) => {
        return state?.filter((i) => i.id !== addressId);
      });
    } catch (error: any) {
      dispatch(
        setNotification({
          show: true,
          severity: "error",
          message: error.response?.data?.message || error.message,
        })
      );
    }
  };

  useEffect(() => {
    checkIf(userId) && getAddressList();
  }, [userId]);
  return { addressList, addressListRef, setAddressList, updateAddressList, createAddressItem, deleteAddressItem };
}
